export class Paging {

    /**
     * Adds ajax to the paginator
     * @param {Object} settings object with settings for paging:
     * valid props: onCatch: fn(err), beforeSend: fn(), callbackFn: fn(json), isLoading, () => boolean
     */
    constructor(settings) {
        const defaultSettings = {
            onCatch: undefined,
            onFinally: undefined,
            beforeSend: undefined,
            callBackFn: undefined,
            isLoading: () => false,
            container: null
        }
        const { onCatch,
            onFinally,
            beforeSend,
            callBackFn,
            isLoading,
            container } = Object.assign(defaultSettings, settings);
        this.onFinally = onFinally;
        this.onCatch = onCatch;
        this.callbackFn = callBackFn;
        this.beforeSend = beforeSend;
        this.container = container;
        this.isLoading = isLoading;
        this.onClick = this.onClick.bind(this);
        this.addPagingClicks();
    }

    async onClick(e) {
        const url = e.currentTarget.href;
        e.preventDefault();
        e.stopPropagation();
        if (this.isLoading()) return;
        if (this.container) await this.scrollToTop()
        let headers = {
            'pragma': 'no-cache',
            'cache-control': 'no-cache',
            'X-Requested-With': 'XMLHttpRequest'
        };
        this.beforeSend && this.beforeSend();
        history.pushState("", "", url)

        fetch(url, {
            headers: headers,
            method: 'GET',
            credentials: 'include'
        }).then(res => res.json())
            .then(x => {
                this.callbackFn(x);
            })
            .finally(() => {
                this.onFinally && this.onFinally();
                this.addPagingClicks();
            })
            .catch(x => this.onCatch && this.onCatch(x));
    }

    addPagingClicks() {
        this.pagingLinks = document.querySelectorAll('.pagination a');
        if (this.pagingLinks) {
            this.pagingLinks.forEach(elem => {
                elem.addEventListener('click', this.onClick)
            })
        }
    }

    async scrollToTop() {
        const containerPosition = this.container.getBoundingClientRect().top;
        if (containerPosition >= 0) return Promise.resolve();

        const target = containerPosition + window.scrollY

        return new Promise(resolve => {
            const clearEvents = () => {
                document.removeEventListener("scroll", scrollTop);
                document.removeEventListener("wheel", clearEvents);
                document.removeEventListener("touchmove", clearEvents);
                resolve();
            }
            const scrollTop = () => {
                const isScrolledTop = window.scrollY - target < 10;
                if (isScrolledTop) {
                    clearEvents();
                }
            }
            document.addEventListener("scroll", scrollTop);
            document.addEventListener("wheel", clearEvents);
            document.addEventListener("touchmove", clearEvents);
            window.scrollTo({ top: target })
        })
    }
}